/**
 * Balance Reconciliation API Client
 * Endpoints for data integrity checks and balance verification
 */

import apiClient from '../client';

/**
 * Perform balance reconciliation
 * Compares cached balances with calculated balances
 */
export const performReconciliation = async () => {
  try {
    const response = await apiClient.get('/wholesale/reconciliation');
    return response.data;
  } catch (error) {
    console.error('Error performing reconciliation:', error);
    throw {
      message: error.response?.data?.error || 'Failed to perform reconciliation',
      status: error.response?.status,
      details: error.response?.data
    };
  }
};

/**
 * Fix all balance discrepancies
 * Updates cached balances to match calculated values
 */
export const fixDiscrepancies = async () => {
  try {
    const response = await apiClient.post('/wholesale/reconciliation/fix');
    return response.data;
  } catch (error) {
    console.error('Error fixing discrepancies:', error);
    throw {
      message: error.response?.data?.error || 'Failed to fix discrepancies',
      status: error.response?.status,
      details: error.response?.data
    };
  }
};

/**
 * Get dashboard comparison
 * Compares reconciliation totals with dashboard stats
 */
export const getDashboardComparison = async () => {
  try {
    const response = await apiClient.get('/wholesale/reconciliation/dashboard-comparison');
    return response.data;
  } catch (error) {
    console.error('Error getting dashboard comparison:', error);
    throw {
      message: error.response?.data?.error || 'Failed to get dashboard comparison',
      status: error.response?.status,
      details: error.response?.data
    };
  }
};

/**
 * Get balance history for a distributor
 * Shows how balances changed over time
 */
export const getBalanceHistory = async (distributorId, months = 12) => {
  try {
    const response = await apiClient.get(
      `/wholesale/reconciliation/balance-history/${distributorId}?months=${months}`
    );
    return response.data;
  } catch (error) {
    console.error('Error getting balance history:', error);
    throw {
      message: error.response?.data?.error || 'Failed to get balance history',
      status: error.response?.status,
      details: error.response?.data
    };
  }
};

export default {
  performReconciliation,
  fixDiscrepancies,
  getDashboardComparison,
  getBalanceHistory
};
